/* Built In Imports */
import NextLink from 'next/link';
import { useEffect, useState } from 'react';

/* External Imports */
import { Box, Link } from '@chakra-ui/react';
import { useMediaQuery } from 'react-responsive';
import { Link as HashLink } from 'react-scroll';

/* Internal Imports */
/* Components */
import SimpleButton from '@components/Buttons/SimpleButton';
import { isOpenInNewTab, refineUrlDomain } from '@components/Utility/utils';

/* Services */
import { isVisInViewport } from '@components/Utility/Shared/SharedService';

/* Mixpanel for SEO*/
import { mixPanel } from '@utils/Mixpanel';

import { useRouter } from 'next/router';

/**
 * Renders SimpleStickyButton
 * @param {Object} sectionContent
 * @param {String} region
 * @param {String} lang
 * @returns {ReactElement} RegisterStickyButton
 */
const SimpleStickyButton = ({ sectionContent, region, lang }) => {
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const [isVisible, setIsVisible] = useState(false);
  const router = useRouter();

  let url = router.asPath;

  const MixpanelEvent = (btnText='',) => {
    if(btnText){
      if (url.indexOf('/sadhanapada')) {
        const Mixpanel = mixPanel(window?.location.pathname);
        Mixpanel.track("sadhanapada_cta_click", {
          cta: "sticky cta",
          program_name: "Sadhanapada 2026",
          element: btnText,
        });
      }
    }
  }

  useEffect(() => {
    window.addEventListener('scroll', listenToScroll);
    return () => window.removeEventListener('scroll', listenToScroll);
  }, []);

  const listenToScroll = () => {
    const footerDiv = document.getElementById('footer');
    const heightToHideFrom = window.innerHeight * 1.3;
    const winScroll =
      document.body.scrollTop || document.documentElement.scrollTop;

    if (winScroll > heightToHideFrom) {
      const footerInViewPort = footerDiv && isVisInViewport(footerDiv);
      if (footerInViewPort) {
        setIsVisible(false);
      } else {
        setIsVisible(true);
      }
    } else {
      setIsVisible(false);
    }
  };

  return (
    isVisible && (
      <Box
        position="fixed"
        sx={{
          filter:
            'drop-shadow(0px 4px 8px #73320C18) ' +
            'drop-shadow(0px 15px 15px #73320C18) ' +
            'drop-shadow(0px 34px 21px #73320C18) ' +
            'drop-shadow(0px 61px 24px #73320C18) ' +
            'drop-shadow(0px 96px 27px #73320C18)',
          color: '#FFFFFF',
        }}
        background={{ base: '#ECE8DE', md: 'none' }}
        top={{ base: 'unset', md: '50%' }}
        py="20px"
        bottom={{ base: '0', md: 'unset' }}
        zIndex="9"
        right={{ base: 'unset', md: '0', xl: '0' }}
        left={{ base: '50%', md: 'unset' }}
        width={{ base: '100%', md: 'auto' }}
        transform={{ base: 'translateX(-50%)', md: 'none' }}
        color="#fff"
        display="flex"
        alignItems="center"
        justifyContent="center"
        onClick={() => url.indexOf('/sadhanapada') ? MixpanelEvent(sectionContent[0]?.buttonText):""}
      >
        {/* <SimpleButton
          style={sectionContent[0]}
          
          region={region}
          lang={lang}
          bType="sticky"
        /> */}
        <NextLink href={refineUrlDomain(sectionContent[0].linkUrl)} passHref legacyBehavior>
            <Link
              className="orange-button"
              display={'block'}
              justifyContent="center"
              alignItems="center"
              fontFamily={'FedraSansStd-medium'}
              bgColor={'#cf4520'}
              h={'auto'}
              minH="50px"
              cursor={'pointer'}
              textAlign={'center'}
              padding={'14px 29px'}
              borderRadius="5px"
              color="#faf7f0"
              textDecoration="none"
              width={'auto'}
              _hover={{
                bg: '#000054',
              }}
              target="_blank"
              fontSize={'20px'}
              fontWeight="500"
              textDecor="none"
              mx={{ base: '0', md: '0' }}
              p={{ base: '13px 20px', md: '13px 20px 15px 20px' }}
              // maxW={{ base: '217px', md: 'auto' }}
              // minW={{ base: '217px', md: 'auto' }}
              mb="0"
              mt="0"
              //onClick={url.lastIndexOf('/sadhanapada') ? MixpanelEvent(style?.buttonText): clickHandler}
              onClick={() => url.indexOf('/volunteer/sadhanapada') > -1 || mixpanelenabled == "true" ? MixpanelEvent(style?.buttonText, cta, program_name, eventid, style?.linkUrl): clickHandler}
            >
              {sectionContent[0]?.buttonText}
            </Link>
          </NextLink>
      </Box>
    )
  );
};

export default SimpleStickyButton;
